
import { useDispatch, useSelector } from 'react-redux';
import { updateFilterValues } from "../../store/features/searchSlice";
import { RootState } from '../../store/store';
import { DropdownSelectOption } from '../../constants/common';
import { ProductCategory } from '../../constants/products';
import { useHandleSearch } from '../../store/features/searchSlice';
import { useAppSelector } from '../../store/hooks';


export interface CategoriesButtonProps {
    icon: React.ReactNode,
    data: DropdownSelectOption<ProductCategory>,
    closeMobileMenu?: () => void;
}

export const CategoriesButton: React.FC<CategoriesButtonProps> = ({ icon, data, closeMobileMenu }) => {

    const dispatch = useDispatch();

    const { handleSearch } = useHandleSearch();
    const filtersState = useAppSelector((state) => state.search.filters);
    const previousSearchFromFilterBtn = useAppSelector((state) => state.search.searchFromFilterBtn);

    const handleCategoryClick = () => {

        closeMobileMenu && closeMobileMenu();

        //dispatch(updateFilterValues({category: data.value}));

        handleSearch({category: data.value, page: filtersState.page, take: filtersState.take}, previousSearchFromFilterBtn, true);
        // window.location.href = window.location + 'search?category=' + data.value;
    }

    return (
        <button onClick={() => { handleCategoryClick(); }} className="relative group flex flex-col lg:text-xs text-[12px] items-center">
            {icon}
            {data.label}
            <div className="z-[-1] group-hover:h-[80px] group-hover:w-[80px] absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] bg-primary_light rounded-full h-0 w-0 transition-all duration-200"></div>
        </button>
    )
}

